/* eslint-disable */
var contentHost = (window.ctsautoconf.CONTENT_SERVER_HOSTNAME.indexOf('http://') > -1 || window.ctsautoconf.CONTENT_SERVER_HOSTNAME.indexOf('https://') > -1) ? new URL(window.ctsautoconf.CONTENT_SERVER_HOSTNAME).host : window.ctsautoconf.CONTENT_SERVER_HOSTNAME
var contentProtocol = (window.ctsautoconf.CONTENT_SERVER_HOSTNAME.indexOf('http://') > -1 || window.ctsautoconf.CONTENT_SERVER_HOSTNAME.indexOf('https://') > -1) ? new URL(window.ctsautoconf.CONTENT_SERVER_HOSTNAME).protocol + '//' : '//'
var contentPrefix = (window.ctsautoconf.CONTENT_SERVER_HOSTNAME_PREFIX ? window.ctsautoconf.CONTENT_SERVER_HOSTNAME_PREFIX : '')
export default {
  businessUnit: (window.ctsautoconf && window.ctsautoconf.BUSINESS_UNIT) || 1,
  businessChannel: (window.ctsautoconf && window.ctsautoconf.BUSINESS_CHANNEL) || null,
  region: (window.ctsautoconf && window.ctsautoconf.REGION) || 1,
  language: (window.ctsautoconf && window.ctsautoconf.LANGUAGE) || 'UK',
  BRAND: (window.ctsautoconf && window.ctsautoconf.BRAND) ? window.ctsautoconf.BRAND : 'igt',
  TEMPLATE: (window.ctsautoconf && window.ctsautoconf.TEMPLATE) ? window.ctsautoconf.TEMPLATE : '',
  THEME_SWITCH: (window.ctsautoconf && window.ctsautoconf.THEME_SWITCH) || false,
  THEME_DEFAULT_STYLE: (window.ctsautoconf && window.ctsautoconf.THEME_DEFAULT_STYLE) || 'dark',
  CURRENCY: (window.ctsautoconf && window.ctsautoconf.CURRENCY) ? window.ctsautoconf.CURRENCY : '$',
  SIGHTLINE_IMG: (window.ctsautoconf && window.ctsautoconf.SIGHTLINE_IMG) || false,
  DISABLE_JOIN_BUTTON: (window.ctsautoconf && window.ctsautoconf.DISABLE_JOIN_BUTTON) || false,
  priceFormat: 'US',
  loginRedirectPage: 'sports',
  liveBettingDataSourceType: '', // - PULL - use kansas; leave it empty for auto switch push/pull
  environmentName: process.env.NODE_ENV, // environment name
  contentServerHostname: (contentProtocol + contentPrefix + (window.ctsautoconf.CONTENT_SERVER_HOSTNAME ? contentHost : window.location.hostname)),
  webPushServiceHostname: ((window.ctsautoconf && window.ctsautoconf.WEBPUSH_SERVICE_HOSTNAME) || '').replace(/:\s*$/, '') || '',
  portPerEnvironment: window.ctsautoconf && window.ctsautoconf.portPerEnvironment ? window.ctsautoconf.portPerEnvironment : {
    'default': '',
    'lbcts.webteam.beg.finsoft.com': '',
    'www.e1.ppbf.qa.beg.finsoft.com': ':4443',
    'cts.webteam.beg.finsoft.com': ':9090',
    'perf.cts.webteam.beg.finsoft.com': ':9090'
  },
  udpateIntervals: {
    marketGroupPeriodicalUpdateInterval: window.ctsautoconf && window.ctsautoconf.marketGroupPeriodicalUpdateInterval ?  window.ctsautoconf.marketGroupPeriodicalUpdateInterval : 60000,
    prematchPeriodicalUpdateInterval: window.ctsautoconf && window.ctsautoconf.prematchPeriodicalUpdateInterval ?  window.ctsautoconf.prematchPeriodicalUpdateInterval : 60000,
    livePeriodicalUpdateInterval: window.ctsautoconf && window.ctsautoconf.livePeriodicalUpdateInterval ?  window.ctsautoconf.livePeriodicalUpdateInterval : 10000
  },
  dateFormats: {
    /** YYYY-MM-DD - The date part of toISOString and intended for default/config component dates. toISOString for 2011-10-05T14:48:00.000Z is isoDate 2011-10-05 */
    isoDate: 'YYYY-MM-DD',
    longDate: 'MM/DD/YYYY',
    shortDate: 'M/D/YY',
    shortDateMG: 'M/D/YY',
    shortDateTime: 'MM/DD/YY h:mm A',
    longDateTime: 'MM/DD/YYYY h:mmA',
    longDateTimeMG: 'MM/DD/YYYY h:mmA',
    longDateTimePlusSecondsAmPm: 'MMMM Do YYYY, h:mm:ss a',
    longTime: 'h:mmA',
    dayAndMonth: 'DD MMMM',
    dayAndMonthAndDateUS: 'MMMM DD h:mmA',
    dayAndMonthUS: 'MMMM DD',
    iso8601: 'YYYY-MM-DDTHH:mm:ss',
    longDateTimeWithName: 'DDD MMM d h:mmA',
    locale: 'en-US',
    longDateWitDayName: 'ddd, MMM Do YYYY',
    dayAndTime: 'ddd h:mm A ',
    switcherDisplayName: 'ENG',
    overrides: {
      'circa': {
        shortDateMG: 'ddd MMM D',
        longDateTimeMG: 'ddd MMM D h:mmA',
        dayAndMonth: 'ddd MMM D'
      },
      'qcasino': {
        shortDateMG: 'ddd MMM D',
        longDateTimeMG: 'ddd MMM D h:mmA'
      }
    }
  },
  appConfigDateFormats: (window.ctsautoconf && window.ctsautoconf.APP_CONFIG_DATE_FORMATS) || {
    en: {
      switcherDisplayName: 'ENG',
      locale: 'en-US',
      longDate: 'MM/DD/YYYY',
      shortDate: 'M/D/YY',
      shortDateMG: 'M/D/YY',
      shortDateTime: 'MM/DD/YY h:mm A',
      longDateTime: 'MM/DD/YYYY h:mmA',
      longDateTimeMG: 'MM/DD/YYYY h:mmA',
      longDateTimePlusSecondsAmPm: 'MMMM Do YYYY, h:mm:ss a',
      longTime: 'h:mmA',
      dayAndMonth: 'DD MMMM',
      dayAndMonthUS: 'MMMM DD',
      longDateTimeWithName: 'DDD MMM D h:mmA',
      dayAndTime: 'ddd h:mm A ',
      longDateWitDayName: 'ddd, MMM Do YYYY'
    },
    es: {
      switcherDisplayName: 'ESP',
      locale: 'es-ES',
      longDate: 'DD/MM/YYYY',
      shortDate: 'D/M/YY',
      shortDateMG: 'D/M/YY',
      shortDateTime: 'D/M/YY HH:mm',
      longDateTime: 'DD/MM/YYYY HH:mm',
      longDateTimeMG: 'DD/MM/YYYY HH:mm',
      longDateTimePlusSecondsAmPm: 'D \'de\' MMMM \'de\' Y, HH:mm:ss',
      longTime: 'HH:mm',
      dayAndMonth: 'DD MMMM',
      dayAndMonthUS: 'DD MMMM',
      longDateTimeWithName: 'DDD MMM D HH:mm',
      dayAndTime: 'ddd HH:mm',
      longDateWitDayName: 'ddd, Do MMM YYYY'
    }
  },
  currencyFormatting: {
    symbol: '$',
    decimalSeparator: '.',
    thousandsSeparator: ',',
    overrides: {
      'ES': {
        decimalSeparator: ',',
        thousandsSeparator: '.'
      }
    }
  },
  timeZone: (window.ctsautoconf && window.ctsautoconf.TIME_ZONE) || 'America/New_York',
  allowInPlayTeasers: false,
  betHistoryInBetslip: (window.ctsautoconf && window.ctsautoconf.SHOW_BETHISTORY_IN_BETSLIP) || false,
  checkActivityInterval: window.ctsautoconf && window.ctsautoconf.CHECK_ACTIVITY_INTERVAL ?  window.ctsautoconf.CHECK_ACTIVITY_INTERVAL : 180000, // 3 minutes
  /**
   * Web applicate data attached to window state. Different parts of PSWS (this website/app) store small bits of data in that object
   */
  webappstate: {},
  /**
   * Automated configuration values - uses package variables with override via static/app-conf.js
   */
  autoconf: {
    CONTENT_SERVER_HOSTNAME: window.ctsautoconf && window.ctsautoconf.CONTENT_SERVER_HOSTNAME,
    CONTENT_SERVER_HOSTNAME_PREFIX: window.ctsautoconf && window.ctsautoconf.CONTENT_SERVER_HOSTNAME_PREFIX,
    WEB_SERVER_HOSTNAME: window.ctsautoconf && ((!window.ctsautoconf.WEB_SERVER_HOSTNAME || window.ctsautoconf.WEB_SERVER_HOSTNAME.indexOf('//') === -1 ? '//' : '') + (window.ctsautoconf.WEB_SERVER_HOSTNAME ||
      (window.location.hostname + ( window.location.port != '' ?  (window.location.port != '80' ? ':' + window.location.port : '') : '')))),
    BETTING_DATA_MATCHER_SERVICE_HOSTNAME: window.ctsautoconf && ((!window.ctsautoconf.BETTING_DATA_MATCHER_SERVICE_HOSTNAME || window.ctsautoconf.BETTING_DATA_MATCHER_SERVICE_HOSTNAME.indexOf('//') === -1 ? '//' : '') + (window.ctsautoconf.BETTING_DATA_MATCHER_SERVICE_HOSTNAME ||
      (window.location.hostname + ( window.location.port != '' ?  (window.location.port != '80' ? ':' + window.location.port : '') : '')))),
    BETCALC_SERVER_HOSTNAME: window.ctsautoconf && window.ctsautoconf.BETCALC_SERVER_HOSTNAME ? (window.ctsautoconf.BETCALC_SERVER_HOSTNAME.indexOf('//') === -1 ? '//' : '') + window.ctsautoconf.BETCALC_SERVER_HOSTNAME : '',
    SEARCH_MANAGER_HOSTNAME: window.ctsautoconf && ((!window.ctsautoconf.SEARCH_MANAGER_HOSTNAME || window.ctsautoconf.SEARCH_MANAGER_HOSTNAME.indexOf('//') === -1 ? '//' : '') + (window.ctsautoconf.SEARCH_MANAGER_HOSTNAME ||
      (window.location.hostname + ( window.location.port != '' ?  (window.location.port != '80' ? ':' + window.location.port : '') : '')))),
    WALLET_URL: window.ctsautoconf && window.ctsautoconf.WALLET_URL,
    GEOCOMPLY_URL: window.ctsautoconf && window.ctsautoconf.GEOCOMPLY_URL,
    WEBPUSH_SERVICE_HOSTNAME: window.ctsautoconf && window.ctsautoconf.WEBPUSH_SERVICE_HOSTNAME,
    STATE: window.ctsautoconf && window.ctsautoconf.STATE,
    IS_BUYBACK_ENABLED: window.ctsautoconf && window.ctsautoconf.IS_BUYBACK_ENABLED ? window.ctsautoconf.IS_BUYBACK_ENABLED : false,
    BUYBACK_REFRESH_INTERVAL: window.ctsautoconf && window.ctsautoconf.BUYBACK_REFRESH_INTERVAL ? window.ctsautoconf.BUYBACK_REFRESH_INTERVAL : 0,
    WALLET_PROVIDER: window.ctsautoconf && window.ctsautoconf.WALLET_PROVIDER ? window.ctsautoconf.WALLET_PROVIDER : '',
    LANGUAGE: (window.ctsautoconf && window.ctsautoconf.LANGUAGE) || 'UK',
    TRANSACTION_SERVER_CALL_MODE: window.ctsautoconf && window.ctsautoconf.TRANSACTION_SERVER_CALL_MODE ? window.ctsautoconf.TRANSACTION_SERVER_CALL_MODE : 'API',
    TRANSACTION_SERVER_API_VERSION: window.ctsautoconf && window.ctsautoconf.TRANSACTION_SERVER_API_VERSION ? window.ctsautoconf.TRANSACTION_SERVER_API_VERSION : 'v1',
    BETCALC_SERVER_API_VERSION: window.ctsautoconf && window.ctsautoconf.BETCALC_SERVER_API_VERSION ? window.ctsautoconf.BETCALC_SERVER_API_VERSION : '',
    BETCALC_SERVER_API_NAME: window.ctsautoconf && window.ctsautoconf.BETCALC_SERVER_API_NAME ? window.ctsautoconf.BETCALC_SERVER_API_NAME : '',
    TRANSACTION_SERVER_API_AUTO_REFRESH_TOKEN: window.ctsautoconf && window.ctsautoconf.TRANSACTION_SERVER_API_AUTO_REFRESH_TOKEN ? window.ctsautoconf.TRANSACTION_SERVER_API_AUTO_REFRESH_TOKEN : false,
    TRANSACTION_SERVER_API_CALL_OVERRIDES: window.ctsautoconf && window.ctsautoconf.TRANSACTION_SERVER_API_CALL_OVERRIDES ? window.ctsautoconf.TRANSACTION_SERVER_API_CALL_OVERRIDES : {},
    GOOGLE_TAGMNGR_ID: window.ctsautoconf && window.ctsautoconf.GOOGLE_TAGMNGR_ID,
    WELCOME_PAGE: window.ctsautoconf && window.ctsautoconf.WELCOME_PAGE ? window.ctsautoconf.WELCOME_PAGE : false,
    ROUTERNAVGROUPS: window.ctsautoconf && window.ctsautoconf.ROUTERNAVGROUPS ? window.ctsautoconf.ROUTERNAVGROUPS : { groups: [], navset: 'sports' },
    PROVIDERSWITHSEPARATEBETFORWPS: window.ctsautoconf && window.ctsautoconf.providersWithSeparateBetForWPS ? window.ctsautoconf.providersWithSeparateBetForWPS : [],
    HIDE_PITCHER_NAME: window.ctsautoconf && window.ctsautoconf.HIDE_PITCHER_NAME ?  window.ctsautoconf.HIDE_PITCHER_NAME : false,
    FIREBASE_ANALYTICS: window.ctsautoconf && window.ctsautoconf.FIREBASE_ANALYTICS ?  window.ctsautoconf.FIREBASE_ANALYTICS : false,
    APPSFLYER_ANALYTICS: window.ctsautoconf && window.ctsautoconf.APPSFLYER_ANALYTICS ?  window.ctsautoconf.APPSFLYER_ANALYTICS : false,
    DISPLAY_ALL_GAMEPERIODS_AS_BIG3: window.ctsautoconf && window.ctsautoconf.displayAllGamePeriodsAsBig3 ? window.ctsautoconf.displayAllGamePeriodsAsBig3 : false,
    SHOW_TEAM_LOGOS: window.ctsautoconf && window.ctsautoconf.SHOW_TEAM_LOGOS ? window.ctsautoconf.SHOW_TEAM_LOGOS : false,
    BIG3_COLUMN_ORDER: window.ctsautoconf && window.ctsautoconf.BIG3_COLUMN_ORDER ? window.ctsautoconf.BIG3_COLUMN_ORDER : {},
    BIG3_IGNORE_SPORTTYPES: window.ctsautoconf && window.ctsautoconf.BIG3_IGNORE_SPORTTYPES ? window.ctsautoconf.BIG3_IGNORE_SPORTTYPES : ['SOCCER', 'TABLE TENNIS', 'TENNIS', 'DARTS', 'MMA', 'BOXING'],
    US_PRICE_FORMAT_SIMPLE_FRACTIONS: window.ctsautoconf && window.ctsautoconf.US_PRICE_FORMAT_SIMPLE_FRACTIONS ? window.ctsautoconf.US_PRICE_FORMAT_SIMPLE_FRACTIONS : false,
    GROUP_PLAYER_PROPS_MARKETS: window.ctsautoconf && window.ctsautoconf.GROUP_PLAYER_PROPS_MARKETS ? window.ctsautoconf.GROUP_PLAYER_PROPS_MARKETS : false,
    SHOW_OUTRIGHT_MARKETNAME: window.ctsautoconf && window.ctsautoconf.SHOW_OUTRIGHT_MARKETNAME? window.ctsautoconf.SHOW_OUTRIGHT_MARKETNAME : false,
    INCOME_ACCESS_ENABLED: window.ctsautoconf && window.ctsautoconf.INCOME_ACCESS_ENABLED ? window.ctsautoconf.INCOME_ACCESS_ENABLED : false,
    LOGIN_USERNAME_TYPE: window.ctsautoconf && window.ctsautoconf.loginUsernameType ? window.ctsautoconf.loginUsernameType : 'MIXED',
    LOGIN_USERNAME_PERSIST: window.ctsautoconf && window.ctsautoconf.LOGIN_USERNAME_PERSIST ? window.ctsautoconf.LOGIN_USERNAME_PERSIST : false,
    MOBILE_BOTTOMNAV_MENUITEMS: window.ctsautoconf && window.ctsautoconf.MOBILE_BOTTOMNAV_MENUITEMS ? window.ctsautoconf.MOBILE_BOTTOMNAV_MENUITEMS : [],
    ROBO: window.ctsautoconf && window.ctsautoconf.ROBO ? window.ctsautoconf.ROBO : false,
    WISH_BET: window.ctsautoconf && window.ctsautoconf.WISH_BET ? window.ctsautoconf.WISH_BET : false,
    USE_ONLY_SHORT_PARTICIPANT_NAMES_ON_MOBILE: window.ctsautoconf && window.ctsautoconf.USE_ONLY_SHORT_PARTICIPANT_NAMES_ON_MOBILE ? window.ctsautoconf.USE_ONLY_SHORT_PARTICIPANT_NAMES_ON_MOBILE : false,
    PM_NEXT_RACE_TIME_TO_START_OFFSET: window.ctsautoconf && window.ctsautoconf.PM_NEXT_RACE_TIME_TO_START_OFFSET ? window.ctsautoconf.PM_NEXT_RACE_TIME_TO_START_OFFSET : 60,
    SESSION_TIME_POPUP: window.ctsautoconf && window.ctsautoconf.SESSION_TIME_POPUP ? window.ctsautoconf.SESSION_TIME_POPUP : false,
    AUTO_LOGIN_AFTER_REGISTRATION: window.ctsautoconf && window.ctsautoconf.autologinAfterRegistration !== undefined ? window.ctsautoconf.autologinAfterRegistration : true,
    USE_RAF_PROMO: window.ctsautoconf && window.ctsautoconf.UseRafPromoCode !== undefined ? window.ctsautoconf.UseRafPromoCode : false,
    GOOGLE_PLACES_API_KEY: window.ctsautoconf && window.ctsautoconf.GooglePlacesApiKey ? window.ctsautoconf.GooglePlacesApiKey : null,
    GOOGLE_PLACES_API_MOBILE_APP_ENABLED: window.ctsautoconf && window.ctsautoconf.GooglePlacesApiMobileAppEnabled !== undefined ? window.ctsautoconf.GooglePlacesApiMobileAppEnabled : false,
    SCAN_DRIVERS_LICENSE: window.ctsautoconf && window.ctsautoconf.SCAN_DRIVERS_LICENSE !== undefined ? window.ctsautoconf.SCAN_DRIVERS_LICENSE : true,
    HOUSE_RULES_REGISTRATION: window.ctsautoconf && window.ctsautoconf.includeHouseRulesInRegistrationPage !== undefined ? window.ctsautoconf.includeHouseRulesInRegistrationPage : false,
    TERMS_CONDITIONS_IS_MANDATORY: window.ctsautoconf && window.ctsautoconf.TermsAndConditionsIsMandatory !== undefined ? window.ctsautoconf.TermsAndConditionsIsMandatory : true,
    USER_NAME_MIN_LENGTH: window.ctsautoconf && window.ctsautoconf.userNameMinLength,
    USER_NAME_MAX_LENGTH: window.ctsautoconf && window.ctsautoconf.userNameMaxLength,
    PWD_MIN_LENGTH: window.ctsautoconf && window.ctsautoconf.pwdMinLength,
    PWD_MAX_LENGTH: window.ctsautoconf && window.ctsautoconf.pwdMaxLength,
    APP_RATING: window.ctsautoconf && window.ctsautoconf.APP_RATING && window.ctsautoconf.APP_RATING.ENABLE ? window.ctsautoconf.APP_RATING : false,
    SHOW_LEG_STATUS_IN_BETHISTORY: window.ctsautoconf && window.ctsautoconf.SHOW_LEG_STATUS_IN_BETHISTORY ? window.ctsautoconf.SHOW_LEG_STATUS_IN_BETHISTORY : false,
    MOBILE_DEBUGGER_DIALOG: window.ctsautoconf && window.ctsautoconf.MOBILE_DEBUGGER_DIALOG ? window.ctsautoconf.MOBILE_DEBUGGER_DIALOG : false,
    XTREMEPUSH_ANALYTICS: window.ctsautoconf && window.ctsautoconf.XTREMEPUSH_ANALYTICS ? window.ctsautoconf.XTREMEPUSH_ANALYTICS : false,
    PAGE_TITLE_IN_HEADER_ON_MOBILE: window.ctsautoconf && window.ctsautoconf.PAGE_TITLE_IN_HEADER_ON_MOBILE ? window.ctsautoconf.PAGE_TITLE_IN_HEADER_ON_MOBILE : false,
    SHOW_WELCOME: window.ctsautoconf && window.ctsautoconf.SHOW_WELCOME ? window.ctsautoconf.SHOW_WELCOME : false,
    SHOW_WHATS_NEW: window.ctsautoconf && window.ctsautoconf.SHOW_WHATS_NEW ? window.ctsautoconf.SHOW_WHATS_NEW : false,
    CONTESTS: window.ctsautoconf && window.ctsautoconf.CONTESTS ? window.ctsautoconf.CONTESTS : false,
    CONTESTS_MEDIA_URL: window.ctsautoconf && window.ctsautoconf.CONTESTS_MEDIA_URL ? window.ctsautoconf.CONTESTS_MEDIA_URL : false,
    CLOSE_ACCOUNT_CONFIRMATION_POPUP: window.ctsautoconf && window.ctsautoconf.CLOSE_ACCOUNT_CONFIRMATION_POPUP ? window.ctsautoconf.CLOSE_ACCOUNT_CONFIRMATION_POPUP : false,
    NUVEI_APPLEPAY_PROXY_URL: window.ctsautoconf && window.ctsautoconf.NUVEI_APPLEPAY_PROXY_URL ? window.ctsautoconf.NUVEI_APPLEPAY_PROXY_URL : 'https://cdn.safecharge.com/safecharge_resources/v1/sc_applepay.min.js',
    TRANSACTION_HISTORY_AMOUNTS: window.ctsautoconf && window.ctsautoconf.transaction_history_amounts ? window.ctsautoconf.transaction_history_amounts : [],
    ACCOUNT_SUMMARY_FLOW: window.ctsautoconf && window.ctsautoconf.ACCOUNT_SUMMARY_FLOW ? window.ctsautoconf.ACCOUNT_SUMMARY_FLOW : false,
    SHOW_LOCALTAX_IN_W2GFORM: window.ctsautoconf && window.ctsautoconf.SHOW_LOCALTAX_IN_W2GFORM ? window.ctsautoconf.SHOW_LOCALTAX_IN_W2GFORM : false,
    SHOW_LIMITS_AFTER_REGISTRATION: window.ctsautoconf && window.ctsautoconf.SHOW_LIMITS_AFTER_REGISTRATION ? window.ctsautoconf.SHOW_LIMITS_AFTER_REGISTRATION : false,
    BETTING_DATA_MATCHER: window.ctsautoconf && window.ctsautoconf.BETTING_DATA_MATCHER ? window.ctsautoconf.BETTING_DATA_MATCHER : false,
    DISABLE_FORGOTTEN_PASSWORD_VIA_EMAIL: window.ctsautoconf && window.ctsautoconf.DISABLE_FORGOTTEN_PASSWORD_VIA_EMAIL ? window.ctsautoconf.DISABLE_FORGOTTEN_PASSWORD_VIA_EMAIL : false,
    MIN_NUM_OF_DAYS_FOR_COOL_OFF: window.ctsautoconf && window.ctsautoconf.MIN_NUM_OF_DAYS_FOR_COOL_OFF ? window.ctsautoconf.MIN_NUM_OF_DAYS_FOR_COOL_OFF : false,
    HIDE_WITHRAWAL_BUTTON_FOR_PAYNEARME_PUSH_DEBIT: window.ctsautoconf && window.ctsautoconf.HIDE_WITHRAWAL_BUTTON_FOR_PAYNEARME_PUSH_DEBIT ? window.ctsautoconf.HIDE_WITHRAWAL_BUTTON_FOR_PAYNEARME_PUSH_DEBIT : false,
    WISHBET_SERVER_HOSTNAME: window.ctsautoconf && window.ctsautoconf.WISHBET_SERVER_HOSTNAME ? window.ctsautoconf.WISHBET_SERVER_HOSTNAME : '',
    WISHBET_SERVER_API_NAME: window.ctsautoconf && window.ctsautoconf.WISHBET_SERVER_API_NAME ? window.ctsautoconf.WISHBET_SERVER_API_NAME : '',
    WISHBET_SERVER_API_VERSION: window.ctsautoconf && window.ctsautoconf.WISHBET_SERVER_API_VERSION ? window.ctsautoconf.WISHBET_SERVER_API_VERSION : '',
    KILLSWITCH_PERIODIC_REFRESH_INTERVAL: window.ctsautoconf && window.ctsautoconf.KILLSWITCH_PERIODIC_REFRESH_INTERVAL ? window.ctsautoconf.KILLSWITCH_PERIODIC_REFRESH_INTERVAL : 0,
	  SUPPORTED_LANGUAGE: window.ctsautoconf && window.ctsautoconf.SUPPORTED_LANGUAGE ? window.ctsautoconf.SUPPORTED_LANGUAGE : false,
    ENABLE_FIT_FOR_PLAY: window.ctsautoconf && window.ctsautoconf.ENABLE_FIT_FOR_PLAY ? window.ctsautoconf.ENABLE_FIT_FOR_PLAY : false,
    ALLOWED_PROMOTION_TYPES: window.ctsautoconf && window.ctsautoconf.ALLOWED_PROMOTION_TYPES ? window.ctsautoconf.ALLOWED_PROMOTION_TYPES : false,
    RACING_IFRAME_SRC: window.ctsautoconf && window.ctsautoconf.RACING_IFRAME_SRC ? window.ctsautoconf.RACING_IFRAME_SRC : 'about:blank',
    MOBILE_LS: window.ctsautoconf && window.ctsautoconf.MOBILE_LS ? window.ctsautoconf.MOBILE_LS : false,
    APP_BIOMETRICS_AUTOMATIC_LOGIN: window.ctsautoconf && window.ctsautoconf.APP_BIOMETRICS_AUTOMATIC_LOGIN ? window.ctsautoconf.APP_BIOMETRICS_AUTOMATIC_LOGIN : false,
    TWO_FACTOR_AUTH_CHANNELS_ORDER: window.ctsautoconf && window.ctsautoconf.TWO_FACTOR_AUTH_CHANNELS_ORDER ? window.ctsautoconf.TWO_FACTOR_AUTH_CHANNELS_ORDER : ['AUTHENTICATOR', 'PHONE', 'EMAIL'],
    AMERICAN_SPORTS: window.ctsautoconf && window.ctsautoconf.AMERICAN_SPORTS ? window.ctsautoconf.AMERICAN_SPORTS : ['NFL', 'ICE HOCKEY', 'BASKETBALL', 'BASEBALL'],
    TRUST_THIS_DEVICE: (window.ctsautoconf && window.ctsautoconf.TRUST_THIS_DEVICE && window.ctsautoconf.TRUST_THIS_DEVICE.defaultValue ? window.ctsautoconf.TRUST_THIS_DEVICE.defaultValue : false) && (window.ctsautoconf && window.ctsautoconf.TRUST_THIS_DEVICE && window.ctsautoconf.TRUST_THIS_DEVICE.remeberUsersChoice ? window.ctsautoconf.TRUST_THIS_DEVICE.remeberUsersChoice : false),
	  AUTH_SERVER_ENABLED: window.ctsautoconf && window.ctsautoconf.AUTH_SERVER_ENABLED ? window.ctsautoconf.AUTH_SERVER_ENABLED : false,
    PLAYER_PERSONALISATION_SERVICE_HOSTNAME: window.ctsautoconf && window.ctsautoconf.PLAYER_PERSONALISATION_SERVICE_HOSTNAME ? (window.ctsautoconf.PLAYER_PERSONALISATION_SERVICE_HOSTNAME.indexOf('//') === -1 ? '//' : '') + window.ctsautoconf.PLAYER_PERSONALISATION_SERVICE_HOSTNAME : '',
    PLAYER_PERSONALISATION_SERVICE_API_NAME: window.ctsautoconf && window.ctsautoconf.PLAYER_PERSONALISATION_SERVICE_API_NAME ? window.ctsautoconf.PLAYER_PERSONALISATION_SERVICE_API_NAME : '',
    PLAYER_PERSONALISATION_SERVICE_API_VERSION: window.ctsautoconf && window.ctsautoconf.PLAYER_PERSONALISATION_SERVICE_API_VERSION ? window.ctsautoconf.PLAYER_PERSONALISATION_SERVICE_API_VERSION : '',
    PLAYER_PERSONALISATION:{
      // Popular Parlays
      enablePopularParlays: false, // enables/disables Popular Parlays feature; default false
      liveEventsAvailableForPopularParlays: false, // allows live events inside parlays; default false
      acceptSelectionsWithNoPrice: false, // allows selections without price; default false
      periodicalUpdatePrematch: 60000, // polling interval for prematch popular parlays (ms); default 60000
      periodicalUpdateLive: 5000, // polling interval for live popular parlays (ms); default 5000
      maxNumOfPopularParlays: 20, // maximum number of popular parlays displayed; default 20
      minNumOfPopularParlays: 3, // minimum number of popular parlays displayed; default 3
      minNumOfSelectionPerParlay: false, // minimum selections per parlay (disabled if false); default false
      maxNumOfSelectionsPerParlay: false, // maximum selections per parlay (disabled if false); default false
      showPopularParlaysOnEventPage: false, // shows popular parlays on event page; default false
      showPopularParlaysOnSportsPage: false, // shows popular parlays on sports page; default false
      multiSportParlaysAvailableOnSportPage: false, // allows multi-sport parlays on sports page; default false

      // Recommended Events
      eventGroupingForRecommendedEvents: 'EVENTSPERCOMPETITION', // grouping mode (EVENTSPERDAY, EVENTSPERCOMPETITION, NONGROUPEDEVENTS); default EVENTSPERCOMPETITION
      recommendedEventsCount: 5, // number of recommended events requested from service; default 5
      showRecommendedEventsOnSportsPage: false, // shows recommended tab on sports page; default false
      enableRecommendedLiveEvents: false,
      recommendedLiveEventsUpdateInterval: 60000,
      recommendedLiveEventsFromOffset: '-24h',

      // Trending Events
      trendingEventsCount: 30, // number of trending events requested from service; default 5
      showTrendingEventsOnSportsPage: false, // shows trending tab on sports page; default false

      // Recommended Markets
      enableRecommendedMarkets: false, // enables/disables Recommended Markets feature; default false
      periodicalUpdateRecommendedMarkets: 60000, // polling interval for recommended markets (ms); default 60000
      isRecommendedTabDefaultOnEventPage: false, // sets recommended tab as default selected on event page; default false

      // VAIX Event tracker
      vaixEventTracker: false, // sends tracking events to VAIX; default false

      // Parlay Zone filters
      availableFilters: ['BET TYPE', 'SPORT', 'LEG COUNT', 'TOTAL ODDS'], // filters displayed on parlay zone page; default ['BET TYPE', 'SPORT', 'LEG COUNT', 'TOTAL ODDS']

      // VAIX Tabs
      vaixTabs: ['recommended', 'trending'],
      periodicalUpdateVaixEvents: 60000,

      // Player Props Widget
      PLAYER_PROPS_WIDGET: {
        subscribe_to_live_events: false,
        selection_count: 10,
        event_count: 10,
        periodic_update_interval: 60000,
        display_logos: false,
        logos_source: ''
      },
      ...(window.ctsautoconf && window.ctsautoconf.PLAYER_PERSONALISATION || {})
    },
    RESEND_PIN_VISIBLE_PERIOD: window.ctsautoconf && window.ctsautoconf.RESEND_PIN_VISIBLE_PERIOD ? window.ctsautoconf.RESEND_PIN_VISIBLE_PERIOD : 10000,
    VAIX_EVENT_TRACKER: window.ctsautoconf && window.ctsautoconf.VAIX_EVENT_TRACKER ? window.ctsautoconf.VAIX_EVENT_TRACKER : {VAIX_API_URL: '', HEADERS: {ID: '', AUTH:'' }},
    FLASH_BETTING:
      window.ctsautoconf && window.ctsautoconf.FLASH_BETTING
        ? {
          ...{
            enableFlashBettingMarkets: false,
            showExternalDescription: true,
            addNewMarketToTheTopOfTheStack: true
          },
          ...window.ctsautoconf.FLASH_BETTING
        }
        : {
          enableFlashBettingMarkets: false,
          showExternalDescription: true,
          addNewMarketToTheTopOfTheStack: true
        },
    CAPACITOR_ENABLED: window.ctsautoconf && window.ctsautoconf.CAPACITOR_ENABLED ? window.ctsautoconf.CAPACITOR_ENABLED : false,
    PAYMENTS: {
      deposit_order: window.ctsautoconf && window.ctsautoconf.PAYMENTS && window.ctsautoconf.PAYMENTS.deposit_order || [],
      withdrawal_order: window.ctsautoconf && window.ctsautoconf.PAYMENTS && window.ctsautoconf.PAYMENTS.withdrawal_order || []
    },
    MARKETS_ORDER_ON_EVENT_PAGE:
      window.ctsautoconf && window.ctsautoconf.MARKETS_ORDER_ON_EVENT_PAGE
        ? {
          ...{
            enable: false,
            saveUserPreferencePerEvent: false,
            saveUserPreferencePerTab: true,
            orderOptions: [
              { value: 'DEFAULT', label: 'Default' },
              { value: 'MARKETNAMEASC', label: 'A-Z' }
            ]
          },
          ...window.ctsautoconf.MARKETS_ORDER_ON_EVENT_PAGE
        }
        : {
          enable: false,
          saveUserPreferencePerEvent: false,
          saveUserPreferencePerTab: true,
          orderOptions: [
            { value: 'DEFAULT', label: 'Default' },
            { value: 'MARKETNAMEASC', label: 'A-Z' }
          ]
        },
    SIS_VIDEO_STREAMING_ENABLED: window.ctsautoconf && window.ctsautoconf.SIS_VIDEO_STREAMING_ENABLED ? window.ctsautoconf.SIS_VIDEO_STREAMING_ENABLED: false,
    FEATURES_TABS: window.ctsautoconf && window.ctsautoconf.FEATURES_TABS ? window.ctsautoconf.FEATURES_TABS : false,
    FAST_SWITCH : window.ctsautoconf && window.ctsautoconf.FAST_SWITCH ? window.ctsautoconf.FAST_SWITCH : false,
    BETZONE: {
      tabs: {
        flashBetting: {
          enabled: false,
          order: 1,
          label: 'Flash Betting'
        },
        popularParlays: {
          enabled: false,
          order: 2,
          label: 'Popular Parlays'
        },
        playerProps: {
          enabled: false,
          order: 3,
          label: 'Player Props'
        }
      },
      ...(window.ctsautoconf && window.ctsautoconf.BETZONE || {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/app.js